import { ContractType } from "../../../../../graphql/generated.ts";

export const contractDetailsTitle = {
  [ContractType.Bond]: "Bond / Securities",
  [ContractType.Credit]: "Credit",
  [ContractType.Guarantee]: "Bank Guarantee",
  [ContractType.LetterOfCredit]: "Irrevocable LC",
  [ContractType.OtherFacilities]: "Other Facilities",
};
